import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";
import { useAppState } from "src/app/state/StateProvider";
import { CheckMailCode } from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/useValidationSchemaMailCode";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import AppIcon from "src/commun/composants/AppIcon";
import CodeMailSendForm from "src/pages/finalisation/etapes/verificationMail/codeMailSend/CodeMailSendForm";
import CodeMailCheckForm from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/CodeMailCheckForm";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { FormikValues } from "formik";
import { fetchUser, setEmail } from "src/app/api/AccountApi";
import { sendCodeMail } from "src/app/api/PublicApi";

export type EmailUpdateProps = {
  readOnly: boolean;
}

const EmailUpdate = ({ readOnly }: EmailUpdateProps) => {
  const [{ user, langue }, dispatch] = useAppState();
  const { tString } = useAppText();
  const [emailEditedSuccessfully, setEmailEditedSuccessfully] = useState(false);
  const [editMail, setEditMail] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [newEmail, setNewEmail] = useState("");

  const handleStepPrecedente = () => {
    setCurrentStep(currentStep - 1);
  }

  const handleStepSuivante = (result: GenericApiResponse<any>, values: FormikValues) => {
    setCurrentStep(currentStep + 1);
    setNewEmail(values.email);
  }

  const startEditMail = () => {
    setEditMail(true);
    setEmailEditedSuccessfully(false);
  }

  const endEditMail = () => {
    setEditMail(false);
    setCurrentStep(0);
  }

  const submitFormAPISendMail = (values: FormikValues) => sendCodeMail(values as VerificationMail, langue);

  const submitFormAPICheckMail = (values: CheckMailCode) => setEmail(values, langue);

  return  (
  <>
    {!editMail ? (
      <>
        <div style={{ display: !readOnly ? "inline-flex" : ""}}>
          <div className="input btn__filter--disabled">
            <AppInput name="currentEmail" value={user!.emailAddress} onChange={() => {}}/>
            <label>{tString("compte.mon.profile.email")}</label>
          </div>
          {!readOnly &&
            <div className="d-inline cursor-pointer">
              <AppIcon name="diter" active size="38px" onClick={startEditMail} />
            </div>
          }
        </div>
        {emailEditedSuccessfully && <p>{tString("update.email.success.message")}</p>}
      </>
    )
      :
    (
      <>
        {currentStep === 0 && (
          <>
            {tString("update.email.message")}
            <CodeMailSendForm
              initialValues={{} as VerificationMail}
              submitSuccessHandler={handleStepSuivante}
              submitFormAPI={submitFormAPISendMail}
              displayCancelBtn={true}
              cancelCallback={endEditMail}
            />
          </>
        )}
        {currentStep === 1 &&
          <CodeMailCheckForm
            initialValues={{email: newEmail} as CheckMailCode}
            submitSuccessHandler={() => {
              setEmailEditedSuccessfully(true);
              endEditMail();
              fetchUser().then(result => {
                dispatch({ type: "setUser", payload: result });
              });
            }}
            stepPrecedente={handleStepPrecedente}
            submitFormAPI={submitFormAPICheckMail}
            askForPassword={true}
            displayCancelBtn={true}
            cancelCallback={endEditMail}
          />
        }
      </>
    )}
  </>
  );
};

export default EmailUpdate;